import { queryOptions } from "@tanstack/react-query";
import { fetchRetoolEmbedUrl } from "@/features/workspace/api/workspace.api";

export const workspaceKeys = {
  all: ["workspace"] as const,
  embedUrl: (tenantId: string) => ["workspace", "embed-url", tenantId] as const,
} as const;

// Embed URLs are single-use: loading one authenticates the whole browser tab as that
// tenant's Retool user. gcTime 0 drops the entry when the panel unmounts so the next mount
// mints a fresh URL instead of replaying a consumed one, and staleTime Infinity keeps a
// mounted panel from refetching itself into an iframe reload (AD-1748). Note that an
// explicit `invalidateQueries()` still refetches this and reloads the iframe.
export function retoolEmbedUrlQueryOptions(tenantId: string) {
  return queryOptions({
    queryKey: workspaceKeys.embedUrl(tenantId),
    queryFn: ({ queryKey }) => fetchRetoolEmbedUrl(queryKey[2]),
    staleTime: Infinity,
    gcTime: 0,
    enabled: !!tenantId,
    meta: { skipGlobalError: true },
  });
}
